import { API } from "@swivl-mono/api-helper";
import { Button, ButtonVariant, Input, Spinner, useAutoFocus } from "@swivl-mono/ui";
import { useEffect, useState } from "react";

import AccountModel from "../../../Models/Account/AccountModel";
import Logo from "../Assets/SwivlLogo.png";
import { MemberInterface } from "@swivl-mono/types";

interface AvatarsState {
  loaded: boolean;
  avatars: { [orgId: number]: string };
}

export function SelectOrg() {
  const { memberships = [] } = AccountModel.useState((s) => s);
  const [avatarsState, setAvatarsState] = useState<AvatarsState>({ loaded: false, avatars: {} });
  const [filteredMemberships, setFilteredMemberships] = useState<MemberInterface[]>([]);
  const focusRef = useAutoFocus(true);

  useEffect(() => {
    if (memberships && memberships?.length > 0) {
      API.Org.avatarsForOrgs(memberships.map((m) => m.org.id).join(",")).then((avatars) => {
        setAvatarsState({ loaded: true, avatars: avatars });
      });

      const sortedMemberships = memberships.sort((a, b) => a.org.name.localeCompare(b.org.name));
      setFilteredMemberships(sortedMemberships);
    }
  }, [memberships]);

  const handleSearchOrganization = (searchValue: string) => {
    const filteredMemberships = memberships?.filter((membership) => membership.org.name?.toLowerCase().includes(searchValue.toLowerCase()));
    setFilteredMemberships(filteredMemberships);
  };

  return (
    <div className="flex flex-col flex-1 w-full items-center pt-4 pb-8 overflow-y-auto [&::-webkit-scrollbar]:bg-transparent [&::-webkit-scrollbar]:rounded-md [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-thumb]:bg-grey-400 [&::-webkit-scrollbar-thumb]:rounded-md">
      <img src={Logo} alt="Swivl Logo" className="w-52 mx-auto mb-8" />

      <h2 className="mb-4 text-center">Select Org</h2>

      <div className="w-1/2 my-4">
        <label className="sr-only" htmlFor="search">
          Organization Search
        </label>
        <Input ref={focusRef} onChange={(e) => handleSearchOrganization(e.target.value)} name="search" isSearch placeholder="Search for an org..." />
      </div>

      <div className="w-1/2 flex-col flex items-center mb-4 justify-center space-y-3">
        {!filteredMemberships?.length && <>You have not joined any organizations. Check your email or contact your organization's administrators.</>}

        {filteredMemberships?.map((membership) => {
          let avatarComponent;
          if (avatarsState.loaded) {
            const url = avatarsState.avatars[membership.org.id]
              ? avatarsState.avatars[membership.org.id]
              : "https://swivl-cdn.s3-us-west-1.amazonaws.com/Hoover-teams-192.png";
            avatarComponent = <img key={membership.org.id} src={url} alt={membership.org.name} className="w-12 h-12 object-cover" />;
          } else {
            avatarComponent = (
              <div className="w-1/4">
                {" "}
                <Spinner />
              </div>
            );
          }

          return (
            <button
              key={membership.id}
              className="w-full cursor-pointer flex-row flex items-center justify-start shadow bg-white"
              onClick={() => AccountModel.selectMember(membership)}
            >
              {avatarComponent}
              <div className="p-2">{membership.org.name}</div>
            </button>
          );
        })}
      </div>
      <div className="flex items-center justify-center">
        <Button variant={ButtonVariant.GHOST} onClick={() => AccountModel.logOut()}>Logout</Button>
      </div>
    </div>
  );
}
